/** Internal dependencies */
import { fetchHandler } from './utilities/fetchHandler';

window.initOnLazyLoad = function (el) {
    if (document.body.hasAttribute('data-ct-rest-image')) {
        if (el.hasAttribute('data-aid') && !el.hasAttribute('data-ct-loading')) {
            const aid = el.dataset?.aid;
            const originalfilename = el.dataset?.originalfilename;

            if (aid.length > 0 && !isNaN(aid)) {
                const parent = el.parentNode;

                if (parent instanceof HTMLPictureElement) {
                    const imageWidth = el.clientWidth;
                    const imageHeight = el.clientHeight;

                    const imageStyles = window.getComputedStyle(el);
                    const imageObjectFit = imageStyles.objectFit;
                    const imageObjectPosition = imageStyles.objectPosition;
                    const breakPointWidth = window.getBootstrapBreakpointWidth();

                    const pixelRatioSplit = window.devicePixelRatio.toString().split('.');
                    if (pixelRatioSplit.length === 1) {
                        pixelRatioSplit[1] = '0';
                    }

                    let hasResponsiveImage = false;
                    const processed = el?.dataset.ctProcessed ? JSON.parse(el.dataset.ctProcessed) : null;
                    let codedValues = btoa(
                        imageWidth +
                            '|' +
                            imageHeight +
                            '|' +
                            breakPointWidth +
                            '|' +
                            pixelRatioSplit[0] +
                            '|' +
                            pixelRatioSplit[1] +
                            '|' +
                            imageObjectFit +
                            '|' +
                            imageObjectPosition
                    );
                    codedValues = codedValues.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');

                    if (processed !== null && processed.includes(codedValues)) {
                        const baseUrl = document.body.dataset.ctRestImageBase;
                        if (baseUrl) {
                            const src = `${baseUrl}${originalfilename}-${aid}-${codedValues}.webp`;
                            el?.setAttribute('src', src);
                            hasResponsiveImage = true;
                        }
                    } else {
                        const fetchUrl = `${document.body.dataset.ctRestImage}${aid}/${codedValues}`;

                        if (!window.ctImageRequested.includes(fetchUrl)) {
                            window.ctImageRequested.push(fetchUrl);
                            fetchHandler({ url: fetchUrl }).catch((errorMsg) => {
                                console.warn('There has been a problem lazy loading images.', errorMsg);
                            });
                        }
                    }

                    el.setAttribute('data-ct-loading', '1');
                    const source = parent.querySelector('source');
                    if (hasResponsiveImage) {
                        source?.remove();
                        el?.removeAttribute('data-srcset');
                        el?.removeAttribute('srcset');
                        el?.setAttribute('width', imageWidth);
                        el?.setAttribute('height', imageHeight);
                    }
                    LazyLoad.resetStatus(el);
                    window.lazyLoadInstance.update();
                }
            }
        }
    }
};

window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.ct-lazy',
    unobserve_completed: true, // set to false if you need tracking if the image leaves the screen
    callback_loading: window.initOnLazyLoad,
});
window.ctImageRequested = [];
